export default __webpack_public_path__ + "static/media/ddXpressBg.7e76ec71.png";